import { reducer as toastrReducer } from 'react-redux-toastr';

import { AnyAction, Reducer, combineReducers } from 'redux';
import {
  AllocationInitialState,
  allocationInitialState,
} from 'redux/allocation/allocation.slice';
import content, {
  ContentInitialState,
  contentInitialState,
} from 'redux/content/content.slice';
import { IMyAllocatorInitialState } from 'redux/saga/lenders/Allocator.types';
import {
  BulkAllocationDetailState,
  BulkAllocationListState,
  BulkAllocationState,
  BulkPaymentHistoryState,
  BulkPaymentState,
  UploadPaymentState,
  UploadState,
} from 'redux/types/Allocation.types';
import { ICreateConfigInitialState } from 'redux/types/CreateConfig.type';
import { FieldSupervisorDashboardState } from 'redux/types/FieldSupervisorDashboard.types';
import { FieldSupervisorVisitSummaryState } from 'redux/types/FieldSupervisorVisitSummary.types';
import { IGetAllocationConfigListInitialState } from 'redux/types/GetAllocationConfigList.type';
import { IGetSelectedConfigDetailsInitialState } from 'redux/types/GetSelectedConfigDetails.type';
import { GroupOperationsState as GroupOperationsStateType } from 'redux/types/GroupOperations.types';
import { IUniqueMyLenderInitialState } from 'redux/types/Lenders.types';
import { IReportInitialState } from 'redux/types/ReportPage.types';
import { IUserEntityInitialState } from 'redux/types/UserEntities.types';
import { IOnboardInitialState } from 'redux/types/UserOnboardDetails.types';
import { IUserPermissionInitialState } from 'redux/types/UserPermission.types';

import AllocationSlice from '../allocation/allocation.slice';
import incentiveReducer, {
  incentiveInitialState,
} from '../slice/incentive/Incentive.slice';
import { IncentiveState } from '../types/Incentive.types';
import {
  IAllocationListInitialState,
  ICampaignListInitialState,
  IOutreachConfigListInitialState,
  IOutreachContentListInitialState,
  IOutreachListInitialState,
} from '../types/Outreach.types';
import ReportPageSlice, {
  reportPageSliceInitialState,
} from './ReportPage.slice';
import AgencyListSlice, {
  AgencyListState,
  agencyListInitState,
} from './admin/onboarding/agency/AgencyList.slice';
import AdvancedPlannerSlice, {
  AdvancedPlannerState,
  advancedPlannerInitState,
} from './advanced-planner/AdvancedPlanner.slice';
import agencySlice, {
  AgencyState,
  agencyDetailsSliceState,
} from './agency-onbording/Agency.slice';
import agencyAllocatorSlice, {
  AgencyAllocatorState,
  agencyAllocatorSliceState,
} from './agency-onbording/AgencyAllocator.slice';
import agencyAuthoritiesSlice, {
  AgencyAuthoritiesState,
  agencyAuthoritiesSliceState,
} from './agency-onbording/AgencyAuthorities.slice';
import agencyDocumentSummarySlice, {
  AgencyDocumentSummaryState,
  agencyDocumentSummaryState,
} from './agency-onbording/AgencyDocumentSummary.slice';
import allocatorSlice, {
  AllocatorState,
  allocatorSliceState,
} from './agency-onbording/Allocator.slice';
import BasicDetailsSlice, {
  BasicDetails,
  basicDetailsState,
} from './agency-onbording/BasicDetails.slice';
import agencyComapnyNameSlice, {
  ComapnyName,
  agencyComapnyNameInitialState,
} from './agency-onbording/CompanyName.slice';
import agencyDocumentSlice, {
  Document,
  documentInitialState,
} from './agency-onbording/Document.slice';
import agencyDocumentColumnSlice, {
  DocumentColumn,
  documentColumnInitialState,
} from './agency-onbording/DocumentColumn.slice';
import ownerDetailsSlice, {
  AgencyOnboardingState,
  ownerDetailsSliceState,
} from './agency-onbording/OwnerDetails.slice';
import productBucketReducer, {
  ProductBucketState,
  productBucketInitialState,
} from './agency-onbording/ProductBucket.slice';
import SignInSlice, {
  SignIn,
  signInDetailsState,
} from './agency-onbording/SignIn.slice';
import SignUpSlice, {
  SignUp,
  signUpDetailsState,
} from './agency-onbording/SignUp.slice';
import AgencyAllocatorConfigSlice, {
  IAgencyAllocatorConfigInitialState,
  agencyAllocatorConfigInitialState,
} from './agencyAllocatorConfig/AgencyAllocatorConfig.slice';
import AgentCountSlice, {
  AgentCountState,
  agentCountInitialState,
} from './agent/AgentCount.slice';
import AgentGroupSlice, {
  AgentGroupState,
  agentGroupInitialState,
} from './agent/AgentGroup.slice';
import AgentListSlice, {
  AgentListState,
  agentDataInitState,
} from './agent/AgentList.slice';
import AgentSummarySlice, {
  AgentSummaryState,
  initialState,
} from './agent/AgentSummary.slice';
import BulkUploadAgentSlice, {
  BulkUploadAgentState,
  bulkUploadAgentInitialState,
} from './agent/BulkUploadAgent.slice';
import AllAgentPerformanceSlice, {
  AgentPerformanceState,
  agentPerformanceInitialState,
} from './all-agent-performance/AgentPerformance.slice';
import CreateConfigSlice, {
  createConfigSliceInitialState,
} from './allocation-config/CreateConfig.slice';
import GetAllocationConfigListSlice, {
  getAllocationConfigListSliceInitialState,
} from './allocation-config/GetAllocationConfigList.slice';
import GetSelectedConfigDetailsSlice, {
  getSelectedConfigInitialState,
} from './allocation-config/GetSelectedConfigDetails.slice';
import AllocationMappingSlice, {
  AllocationMappingState,
  allocationMappingInitialState,
} from './allocation-mapping/AllocationMapping.slice';
import AllocationDetailsSlice, {
  AllocationDetailsState,
  allocationDataInitState,
} from './allocation/AllocationDetails.slice';
import AllocationListNSlice, {
  AllocationListState,
  allocationInitState,
} from './allocation/AllocationList.slice';
import BulkAllocationSlice, {
  bulkAllocationInitialState,
} from './allocation/BulkAllocation.slice';
import {
  bulkAllocationDetailInitialState,
  bulkAllocationDetailReducer,
  bulkAllocationListInitialState,
  bulkAllocationListReducer,
} from './allocation/BulkAllocationList.slice';
import BulkPaymentSlice, {
  bulkPaymentInitialState,
} from './allocation/BulkPayment.slice';
import BulkPaymentHistorySlice, {
  bulkPaymentHistoryInitialState,
} from './allocation/BulkPaymentHistory.slice';
import ChannelAllocationSlice, {
  ChannelAllocationInitialState,
  channelAllocationInitialState,
} from './allocation/ChannelAllocation.slice';
import PaymentListNSlice, {
  PaymentInitState,
  PaymentListState,
} from './allocation/PaymentList.slice';
import UploadAllocationSlice, {
  uploadAllocationInitialState,
} from './allocation/UploadAllocation.slice';
import UploadPaymentFileSlice, {
  uploadPaymentFileInitialState,
} from './allocation/UploadPaymentFile.slice';
import CallPlannerSlice, {
  CallPlannerState,
  callPlannerInitState,
} from './call-center/CallPlanner.slice';
import CallCampaignSlice, {
  CallCampaignState,
  callCampaignInitialState,
} from './callCampaign/CallCampaign.slice';
import AllocationListSlice, {
  allocationListInitialState,
} from './campaign-planner/AllocationList.slice';
import CamapignListSlice, {
  campaignListInitialState,
} from './campaign-planner/CamapignList.slice';
import ConfigListSlice, {
  outreachConfigListInitialState,
} from './campaign-planner/ConfigList.slice';
import ContentListSlice, {
  outreachContentListInitialState,
} from './campaign-planner/ContentList.slice';
import OutreachListSlice, {
  outreachListInitialState,
} from './campaign-planner/OutreachList.slice';
import CampaignSlice, {
  CampaignState,
  campaignInitialState,
} from './campaign/Campaign.slice';
import ComplianceAgencyVisitSlice, {
  AgencyVisitState as ComplianceAgencyVisitState,
  agencyVisitInitialState as complianceAgencyVisitInitialState,
} from './compliance/agency-visit/AgencyVisit.slice';
import ComplianceAgencySlice, {
  AgencyState as ComplianceAgencyState,
  agencyInitialState as complianceAgencyInitialState,
} from './compliance/agency/Agency.slice';
import ComplianceDashboardSlice, {
  DashboardState as ComplianceDashboardState,
  dashboardInitialState as complianceDashboardInitialState,
} from './compliance/dashboard/Dashboard.slice';
import ComplianceDocumentSlice, {
  DocumentState as ComplianceDocumentState,
  documentInitialState as complianceDocumentInitialState,
} from './compliance/document/Document.slice';
import ComplianceRecordingSlice, {
  RecordingState as ComplianceRecordingState,
  recordingInitialState as complianceRecordingInitialState,
} from './compliance/recording/Recording.slice';
import CRMSlice, { CRMInitState, crmInitState } from './crm/CRM.slice';
import GetDerivedFieldSlice, {
  IGetDerivedFieldInitialState,
  getDerivedFieldSliceInitialState,
} from './derived-field/GetDerivedField.slice';
import agencyDiscoveryReducer, {
  AgencyDiscoveryInitialState,
  IAgencyDiscoveryState,
} from './discovery/AgencyDiscovery.slice';
import emailTemplatesReducer, {
  EmailTemplatesState,
} from './email-templates/EmailTemplates.slice';
import FieldSupervisorDashboardSlice, {
  fieldSupervisorDashboardInitState,
} from './field-supervisor/FieldSupervisorDashboard.slice';
import FieldSupervisorVisitSummarySlice, {
  fieldSupervisorVisitSummaryInitialState,
} from './field-supervisor/FieldSupervisorVisitSummary.slice';
import FieldPlannerSlice, {
  FieldPlannerState,
  fieldPlannerInitState,
} from './field/FieldPlanner.slice';
import FilterSlice, {
  FilterState,
  filterInitState,
} from './filter/Filter.slice';
import GroupOperationsSlice from './group-operations/GroupOperations.slice';
import DesignationManagementSlice, {
  IDesignationManagementInitialState,
  designationManagementInitialState,
} from './hierarchy-management/DesignationManagement.slice';
import EmployeeProfileSlice, {
  employeeProfileInitialState,
} from './hierarchy-management/EmployeeProfile.slice';
import hierarchySetupSlice, {
  IHierarchySetupInitialState,
  hierarchySetupInitialState,
} from './hierarchy-management/hierarchySetup.slice';
import { IEmployeeProfileInitialState } from './hierarchy-management/types';
import MyLendersSlice, {
  myLendersInitialState,
} from './lenders/MyLenders.slice';
import PendingLendersSlice, {
  pendingLendersInitialState,
} from './lenders/PendingLenders.slice';
import rejectedLenderReducer, {
  rejectedLendersInitialState,
} from './lenders/RejectedLenders.slice';
import uniqueLenderSlice, {
  myUniqueLendersInitialState,
} from './lenders/unqueLender.slice';
import ReportSlice, {
  ReportsState,
  reportsInitState,
} from './report/Reports.slice';
import downloadScoredFileReducer, {
  DownloadScoredFileState,
  downloadScoredFileInitialState,
} from './score/DownloadScoredFile.slice';
import scoreListReducer, {
  ScoreListState,
  scoreListInitialState,
} from './score/ScoreList.slice';
import uploadScoreReducer, {
  UploadScoreState,
  uploadScoreInitialState,
} from './score/UploadScore.slice';
import {
  ISettingsState,
  settingsInitialState,
  settingsReducer,
} from './settings';
import Strategy, {
  StrategyStateInitialStateTypes,
  strategyInitialState,
} from './strategy/strategy';
import SupervisorDashboardSlice, {
  SupervisorDashboardState,
  supervisorDashboardInitState,
} from './supervisor-dashboard/SupervisorDashboard.slice';
import ErrorModalReducer, {
  ErrorModalState,
  errorModalInitialState,
} from './ui/ErrorModal.slice';
import UserConfigurationSlice, {
  IUserConfigurationInitialState,
  userConfigurationInitialState,
} from './user/UserConfiguration.slice';
import UserEntitiesSlice, {
  userEntitiesSliceInitialState,
} from './user/UserEntities.slice';
import UserOnboardSlice, {
  onboardInitialState,
} from './user/UserOnboard.slice';
import UserPermissionSlice, {
  userPermissionSliceInitialState,
} from './user/UserPermission.slice';

// Define the root state shape
export interface RootReducerState {
  reportPage: IReportInitialState;
  toastr: any; // Adjust the type as needed for toastrReducer
  userEntities: IUserEntityInitialState;
  userPermission: IUserPermissionInitialState;
  userConfiguration: IUserConfigurationInitialState;
  createConfig: ICreateConfigInitialState;
  getAllocationConfigList: IGetAllocationConfigListInitialState;
  getSelectedConfigDetails: IGetSelectedConfigDetailsInitialState;
  allocation: AllocationInitialState;
  myLenders: IMyAllocatorInitialState;
  pendingLenders: IMyAllocatorInitialState;
  rejectedLenders: IMyAllocatorInitialState;
  uniqueLenders: IUniqueMyLenderInitialState;
  strategy: StrategyStateInitialStateTypes;
  outreachList: IOutreachListInitialState;
  outreachConfigList: IOutreachConfigListInitialState;
  outreachContentList: IOutreachContentListInitialState;
  derivedField: IGetDerivedFieldInitialState;
  userOnboardDetails: IOnboardInitialState;
  campaignList: ICampaignListInitialState;
  allocationList: IAllocationListInitialState;
  designationManagement: IDesignationManagementInitialState;
  hierarchySetupList: IHierarchySetupInitialState;
  employeeProfile: IEmployeeProfileInitialState;
  settings: ISettingsState;
  derivedFiled: IGetDerivedFieldInitialState;
  content: ContentInitialState;
  uploadAllocationFile: UploadState;
  uploadPaymentFile: UploadPaymentState;
  bulkPayment: BulkPaymentState;
  bulkPaymentHistory: BulkPaymentHistoryState;
  bulkAllocation: BulkAllocationState;
  bulkAllocationList: BulkAllocationListState;
  bulkAllocationDetail: BulkAllocationDetailState;
  allocationDetail: AllocationDetailsState;
  allocationListTable: AllocationListState; // yucollect
  paymentListTable: PaymentListState; // yucollect
  agentList: AgentListState;
  channelAllocation: ChannelAllocationInitialState;
  agentGroup: AgentGroupState;
  callCampaign: CallCampaignState;
  agentCount: AgentCountState;
  advancedPlanner: AdvancedPlannerState;
  bulkUploadAgentState: BulkUploadAgentState;
  callPlanner: CallPlannerState;
  agentSummary: AgentSummaryState;
  fieldPlanner: FieldPlannerState;
  fieldSupervisorDashboard: FieldSupervisorDashboardState;
  CRM: CRMInitState;
  filter: FilterState;
  basicDetails: BasicDetails;
  signUpDetails: SignUp;
  signInDetails: SignIn;
  documentColumn: DocumentColumn;
  agencyCompanyName: ComapnyName;
  document: Document;
  allocatorMaster: AllocatorState;
  agencyAllocators: AgencyAllocatorState;
  agencyAuthorities: AgencyAuthoritiesState;
  ownerDetails: AgencyOnboardingState;
  agencyDetails: AgencyState;
  agencyDocumentSummary: AgencyDocumentSummaryState;
  reports: ReportsState;
  agencyList: AgencyListState;
  allocationMapping: AllocationMappingState;
  complianceDocument: ComplianceDocumentState;
  complianceAgency: ComplianceAgencyState;
  complianceAgencyVisit: ComplianceAgencyVisitState;
  complianceDashboard: ComplianceDashboardState;
  complianceRecording: ComplianceRecordingState;
  campaign: CampaignState;
  supervisorDashboard: SupervisorDashboardState;
  allAgentPerformance: AgentPerformanceState;
  incentive: IncentiveState;
  fieldSupervisorVisitSummary: FieldSupervisorVisitSummaryState;
  productBucket: ProductBucketState;
  agencyDiscovery: IAgencyDiscoveryState;
  emailTemplates: EmailTemplatesState;
  errorModal: ErrorModalState;
  groupOperations: GroupOperationsStateType;
  scoreList: ScoreListState;
  downloadScoredFile: DownloadScoredFileState;
  uploadScore: UploadScoreState;
  agencyAllocatorConfig: IAgencyAllocatorConfigInitialState;
}

export const appInitialState: RootReducerState = {
  reportPage: reportPageSliceInitialState,
  toastr: {},
  userEntities: userEntitiesSliceInitialState,
  userPermission: userPermissionSliceInitialState,
  userConfiguration: userConfigurationInitialState,
  createConfig: createConfigSliceInitialState,
  getAllocationConfigList: getAllocationConfigListSliceInitialState,
  getSelectedConfigDetails: getSelectedConfigInitialState,
  allocation: allocationInitialState,
  myLenders: myLendersInitialState,
  pendingLenders: pendingLendersInitialState,
  rejectedLenders: rejectedLendersInitialState,
  uniqueLenders: myUniqueLendersInitialState,
  strategy: strategyInitialState,
  outreachList: outreachListInitialState,
  outreachConfigList: outreachConfigListInitialState,
  outreachContentList: outreachContentListInitialState,
  userOnboardDetails: onboardInitialState,
  campaignList: campaignListInitialState,
  allocationList: allocationListInitialState,
  derivedField: getDerivedFieldSliceInitialState,
  hierarchySetupList: hierarchySetupInitialState,
  designationManagement: designationManagementInitialState,
  employeeProfile: employeeProfileInitialState,
  settings: settingsInitialState,
  derivedFiled: getDerivedFieldSliceInitialState,
  content: contentInitialState,
  uploadAllocationFile: uploadAllocationInitialState,
  uploadPaymentFile: uploadPaymentFileInitialState,
  bulkPayment: bulkPaymentInitialState,
  bulkPaymentHistory: bulkPaymentHistoryInitialState,
  bulkAllocation: bulkAllocationInitialState,
  bulkAllocationList: bulkAllocationListInitialState,
  bulkAllocationDetail: bulkAllocationDetailInitialState,
  allocationDetail: allocationDataInitState,
  allocationListTable: allocationInitState,
  paymentListTable: PaymentInitState,
  agentList: agentDataInitState,
  channelAllocation: channelAllocationInitialState,
  agentGroup: agentGroupInitialState,
  callCampaign: callCampaignInitialState,
  agentCount: agentCountInitialState,
  advancedPlanner: advancedPlannerInitState,
  bulkUploadAgentState: bulkUploadAgentInitialState,
  callPlanner: callPlannerInitState,
  agentSummary: initialState,
  fieldPlanner: fieldPlannerInitState,
  fieldSupervisorDashboard: fieldSupervisorDashboardInitState,
  CRM: crmInitState,
  filter: filterInitState,
  basicDetails: basicDetailsState,
  signUpDetails: signUpDetailsState,
  signInDetails: signInDetailsState,
  documentColumn: documentColumnInitialState,
  agencyCompanyName: agencyComapnyNameInitialState,
  document: documentInitialState,
  allocatorMaster: allocatorSliceState,
  agencyAllocators: agencyAllocatorSliceState,
  agencyAuthorities: agencyAuthoritiesSliceState,
  ownerDetails: ownerDetailsSliceState,
  agencyDetails: agencyDetailsSliceState,
  agencyDocumentSummary: agencyDocumentSummaryState,
  reports: reportsInitState,
  agencyList: agencyListInitState,
  allocationMapping: allocationMappingInitialState,
  complianceDocument: complianceDocumentInitialState,
  complianceAgency: complianceAgencyInitialState,
  complianceAgencyVisit: complianceAgencyVisitInitialState,
  complianceDashboard: complianceDashboardInitialState,
  complianceRecording: complianceRecordingInitialState,
  campaign: campaignInitialState,
  supervisorDashboard: supervisorDashboardInitState,
  allAgentPerformance: agentPerformanceInitialState,
  incentive: incentiveInitialState,
  fieldSupervisorVisitSummary: fieldSupervisorVisitSummaryInitialState,
  productBucket: productBucketInitialState,
  agencyDiscovery: AgencyDiscoveryInitialState,
  emailTemplates: {
    templates: [],
    loading: false,
    error: null,
  },
  errorModal: errorModalInitialState,
  groupOperations: {
    stats: { inProgressJobs: 0 },
    jobs: [],
    isConnected: false,
    error: null,
  },
  scoreList: scoreListInitialState,
  downloadScoredFile: downloadScoredFileInitialState,
  uploadScore: uploadScoreInitialState,
  agencyAllocatorConfig: agencyAllocatorConfigInitialState,
};

const AppReducer: Reducer<RootReducerState> = combineReducers<RootReducerState>(
  {
    reportPage: ReportPageSlice,
    hierarchySetupList: hierarchySetupSlice,
    toastr: toastrReducer,
    userEntities: UserEntitiesSlice,
    userPermission: UserPermissionSlice,
    userConfiguration: UserConfigurationSlice,
    createConfig: CreateConfigSlice,
    getAllocationConfigList: GetAllocationConfigListSlice,
    allocation: AllocationSlice,
    getSelectedConfigDetails: GetSelectedConfigDetailsSlice,
    myLenders: MyLendersSlice,
    pendingLenders: PendingLendersSlice,
    rejectedLenders: rejectedLenderReducer,
    uniqueLenders: uniqueLenderSlice,
    userOnboardDetails: UserOnboardSlice,
    strategy: Strategy,
    outreachList: OutreachListSlice,
    outreachConfigList: ConfigListSlice,
    outreachContentList: ContentListSlice,
    campaignList: CamapignListSlice,
    allocationList: AllocationListSlice,
    allocationListTable: AllocationListNSlice,
    paymentListTable: PaymentListNSlice,
    derivedField: GetDerivedFieldSlice,
    designationManagement: DesignationManagementSlice,
    employeeProfile: EmployeeProfileSlice,
    settings: settingsReducer,
    derivedFiled: GetDerivedFieldSlice,
    content,
    uploadAllocationFile: UploadAllocationSlice,
    uploadPaymentFile: UploadPaymentFileSlice,
    bulkPayment: BulkPaymentSlice,
    bulkPaymentHistory: BulkPaymentHistorySlice,
    bulkAllocation: BulkAllocationSlice,
    bulkAllocationList: bulkAllocationListReducer,
    bulkAllocationDetail: bulkAllocationDetailReducer,
    allocationDetail: AllocationDetailsSlice,
    agentList: AgentListSlice,
    channelAllocation: ChannelAllocationSlice,
    agentGroup: AgentGroupSlice,
    callCampaign: CallCampaignSlice,
    agentCount: AgentCountSlice,
    advancedPlanner: AdvancedPlannerSlice,
    bulkUploadAgentState: BulkUploadAgentSlice,
    callPlanner: CallPlannerSlice,
    agentSummary: AgentSummarySlice,
    fieldPlanner: FieldPlannerSlice,
    fieldSupervisorDashboard: FieldSupervisorDashboardSlice,
    fieldSupervisorVisitSummary: FieldSupervisorVisitSummarySlice,
    CRM: CRMSlice,
    filter: FilterSlice,
    basicDetails: BasicDetailsSlice,
    signUpDetails: SignUpSlice,
    signInDetails: SignInSlice,
    documentColumn: agencyDocumentColumnSlice,
    agencyCompanyName: agencyComapnyNameSlice,
    document: agencyDocumentSlice,
    allocatorMaster: allocatorSlice,
    agencyAllocators: agencyAllocatorSlice,
    agencyAuthorities: agencyAuthoritiesSlice,
    ownerDetails: ownerDetailsSlice,
    agencyDetails: agencySlice,
    agencyDocumentSummary: agencyDocumentSummarySlice,
    reports: ReportSlice,
    agencyList: AgencyListSlice,
    allocationMapping: AllocationMappingSlice,
    complianceDocument: ComplianceDocumentSlice,
    complianceAgency: ComplianceAgencySlice,
    complianceAgencyVisit: ComplianceAgencyVisitSlice,
    complianceDashboard: ComplianceDashboardSlice,
    complianceRecording: ComplianceRecordingSlice,
    campaign: CampaignSlice,
    supervisorDashboard: SupervisorDashboardSlice,
    allAgentPerformance: AllAgentPerformanceSlice,
    incentive: incentiveReducer,
    productBucket: productBucketReducer,
    agencyDiscovery: agencyDiscoveryReducer,
    emailTemplates: emailTemplatesReducer,
    errorModal: ErrorModalReducer,
    groupOperations: GroupOperationsSlice,
    scoreList: scoreListReducer,
    downloadScoredFile: downloadScoredFileReducer,
    uploadScore: uploadScoreReducer,
    agencyAllocatorConfig: AgencyAllocatorConfigSlice,
  }
);

const rootReducer: Reducer<RootReducerState, AnyAction> = (state, action) => {
  if (action.type === 'RESET') {
    // Assuming 'storage' has a method 'removeItem' and you are using 'redux-persist'
    localStorage.removeItem('persist:root');
  }
  return AppReducer(state, action);
};
export default rootReducer;
